import React from 'react';
import { withFirebase } from '../Firebase';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import { Container, Row, Col } from 'react-bootstrap';
import EnhancedTable from '../Table';
import EnhancedTable2 from '../Table2';
import Spinner from 'react-bootstrap/Spinner';
import RestServices from '../services/RestServices.js';
import {
    getStorage,
    ref,
    list,
    deleteObject,
    getDownloadURL
} from 'firebase/storage';

//import "firebase/auth";
//const firebase = require('firebase')

class EditCarousel extends React.Component {
    _isMounted = false;

    state = {
        flag: 0,
        showLoading: false,
        alert: 0,
        alertMessage: ''
    };
    rows = [];
    posts = [];
    postedlist = [];
    fetchedPosts = [];

    headCells = [
        { id: 'name', numeric: false, disablePadding: true, label: 'File name' }
    ];

    storageref = async () => {
        var rows1 = [];

        const storage = getStorage();
        const listRef = ref(storage, 'SliderImages');
        const firstPage = await list(listRef);
        for (let r of firstPage.items) {
            rows1.push({ name: r.name, date: '' });
        }
        this.rows = rows1;

        await RestServices.getSliderImagesList(
            localStorage.getItem('FirebaseToken')
        )
            .then((response) => response.json())
            .then(async (responseData) => {
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            showLoading: false,
                            flag: 0,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    var rows2 = [];
                    this.fetchedPosts = responseData;
                    this.fetchedPosts.forEach((value) => {
                        this.postedlist.push(value.ImageName);
                        rows2.push({ name: value.ImageName });
                    });
                    this.posts = rows2;
                    if (this._isMounted) {
                        this.setState({ showLoading: false, flag: 1 });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        showLoading: false,
                        flag: 0,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    };

    fetchedPostsIndeFinder = (value) => {
        for (let i = 0; i < this.fetchedPosts.length; i++) {
            if (this.fetchedPosts[i].ImageName === value) return i;
        }
        return -1;
    };

    async componentDidMount() {
        this._isMounted = true;
        try {
            await this.storageref();
        } catch (error) {
            console.log(error.message)
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidUpdate(prevProps, prevState) {
        if (this.state.flag === 2) {
            try {
                await this.storageref();
            } catch (error) {}
        }
    }

    changeFlagState = () => {
        if (this._isMounted) {
            this.setState({ flag: 2 });
        }
    };

    changeFlagStateForStorage = () => {
        if (this._isMounted) {
            this.setState({ flag: -1 });
        }
    };

    deleteImages = async (selected) => {
        if (this._isMounted) {
            this.setState({ flag: 0 });
        }
        await selected.forEach(async (name, index) => {
            const storage = getStorage();
            const desertRef = ref(storage, 'SliderImages/' + name);
            deleteObject(desertRef)
                .then(async () => {
                    await RestServices.deleteSliderImages(
                        localStorage.getItem('FirebaseToken'),
                        this.fetchedPosts[this.fetchedPostsIndeFinder(name)]
                    )
                        .then((response) => response.json())
                        .then(async (responseData) => {});
                })
                .catch((error) => {});
        });
        if (this._isMounted) {
            await this.setState({ flag: 2 });
        }
    };

    deletePosts = async (selected) => {
        if (this._isMounted) {
            this.setState({ flag: 0 });
        }
        await selected.forEach(async (name, index) => {
            await RestServices.deleteSliderImages(
                localStorage.getItem('FirebaseToken'),
                this.fetchedPosts[this.fetchedPostsIndeFinder(name)]
            )
                .then((response) => response.json())
                .then(async (responseData) => {
                    
                });
        });
        if (this._isMounted) {
            this.setState({ flag: 2 });
        }
    };

    addPosts = async (selected) => {
        if (this._isMounted) {
            this.setState({ flag: 0 });
        }
        await selected.forEach(async (name, index) => {
            const storage = getStorage();

            await getDownloadURL(ref(storage, 'SliderImages/' + name)).then(
                async (imageUrl) => {
                    await RestServices.updateSliderImages(
                        localStorage.getItem('FirebaseToken'),
                        { ImageName: name, ImageURL: imageUrl }
                    )
                        .then((response) => response.json())
                        .then(async (responseData) => {
                            
                        });
                }
            );
        });
        if (this._isMounted) {
            await this.setState({ flag: 2 });
        }
    };

    render() {
        return (
            <div>
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                    <Row>
                        <Col>
                            <br />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Nav variant="pills">
                                <Nav.Item>
                                    <Nav.Link eventKey="first">
                                        Remove Posts
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="second">
                                        Store Images
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <hr />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Tab.Content>
                                <Tab.Pane eventKey="first">
                                    {this.state.flag === 1 ? (
                                        <EnhancedTable2
                                            rows={this.posts}
                                            flagHandler={this.changeFlagState}
                                            deletePosts={(selectedRows) =>
                                                this.deletePosts(selectedRows)
                                            }
                                        />
                                    ) : (
                                        <Spinner animation="border" />
                                    )}
                                </Tab.Pane>
                                <Tab.Pane eventKey="second">
                                    {this.state.flag === 1 ? (
                                        <EnhancedTable
                                            publishPosts={(selected) =>
                                                this.addPosts(selected)
                                            }
                                            headCells={this.headCells}
                                            rows={this.rows}
                                            posted={this.postedlist}
                                            flagHandler={this.changeFlagState}
                                            deleteRows={(selectedRows) =>
                                                this.deleteImages(selectedRows)
                                            }
                                            changeFlagStateForStorage={
                                                this.changeFlagStateForStorage
                                            }
                                        />
                                    ) : (
                                        <Spinner animation="border" />
                                    )}
                                </Tab.Pane>
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            </div>
        );
    }
}

export default withFirebase(EditCarousel);
